module.exports = __webpack_public_path__ + "assets/img/1f5902ae6db1710446b11851a0e3d085.svg";